import React from 'react';

interface Props {
  navigation: React.ReactNode;
  body: React.ReactNode;
}
function ProfileContainer({ navigation, body }: Props) {
  return (
    <div className='flex w-full justify-between gap-6'>
      <div className="md:w-1/3 2xl:w-1/4 rounded-2xl border border-secondary-200 bg-general-card-light dark:border-white/20 dark:bg-general-card-dark">
        {navigation}
      </div>
      <div className=' md:w-2/3 2xl:w-3/4'>
        {body}
      </div>
    </div>
  );
}

export default ProfileContainer;
